var exports = {
  "W": "shared.module__subsectionTitle___YVFkWG",
};

module.exports = exports;
